import { request } from "@/libs";
const timeout = 8000;

export default function validateNonce({ userId, id, nonce }) {
	return request("/server/nonce-validation",
		{
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ userId, id, nonce })
		},
		timeout
	)
		.then(res => res.json());
}



// WEBPACK FOOTER //
// ./src/api/validate-nonce.js